import { TimeDirection } from "./DurationFormatter";
import i18next from "i18next";
import { IllegalStateError } from "shared-ts-utils-core";

export class PartsFixer {
  private readonly timeDirection: TimeDirection;
  private readonly isPast: boolean;

  constructor(args: { timeDirection: TimeDirection }) {
    this.timeDirection = args.timeDirection;
    this.isPast = args.timeDirection === "past";
  }

  flatten = (
    allParts: Array<Array<Intl.RelativeTimeFormatPart>>
  ): Array<Intl.RelativeTimeFormatPart> => {
    const modifiedParts: Array<Intl.RelativeTimeFormatPart> = [];
    const isPast = this.isPast;

    for (let o = 0; o < allParts.length; o++) {
      const parts = allParts[o];
      const isLastDurationUnit = o === allParts.length - 1;
      if (
        (parts[0].type === "literal" && this.timeDirection === "none") ||
        o !== 0
      ) {
        parts.splice(0, 1);
      }
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const isLastPart = i === parts.length - 1;
        if (
          isPast &&
          isLastPart &&
          !isLastDurationUnit &&
          part.type === "literal"
        ) {
          modifiedParts.push({
            ...part,
            // Keep the unit, drop the trailing " ago"/" siden"/etc.
            value: this.stripTrailingWord(part.value),
          });
        } else {
          modifiedParts.push(part);
        }
      }
    }
    return modifiedParts;
  };

  private getAgoTranslated(): string {
    const ago = i18next.t("shared-ts-ui-time:ago");
    if (ago === undefined) {
      throw new IllegalStateError("Translation for 'ago' does not exist");
    }
    return " " + ago;
  }

  private partHasAgo(part: Intl.RelativeTimeFormatPart): boolean {
    const agoTranslated = this.getAgoTranslated();
    return part.type === "literal" && part.value.includes(agoTranslated);
  }

  // Removes a trailing space + word (letters, optional dot) at the end of the string.
  // Examples:
  //  "h ago"   -> "h"
  //  "t siden" -> "t"
  //  "min."    -> "min" (if some locales add punctuation)
  private stripTrailingWord(input: string): string {
    return input.replace(/\s+\p{L}+\.?$/u, "");
  }
}
